<template>
  <div v-html="list"></div>
</template>

<script>
export default {
  name: "g-format-html",
  props: ["inputData"],
  data() {
    return {};
  },
  mounted: function() {
    // console.log(this.inputData);
  },
  computed: {
    list() {
      if (!this.inputData) {
        return;
      }
      const { n, merz, doc, addLink, seite, accordion, modus } = this.inputData;

      let div = this.$_getNewHtmlElement(n.html, merz, doc, addLink);
      div.classList.add("ksm-accordion__section");
      div.setAttribute("data-acco", accordion.id + "#" + n.ID);
      let obj = seite.$_accoId_transcript_mapping[n.category].find(c => {
        return c.ID === n.ID;
      });

      if (obj && obj.ids.length > 0) {
        div.setAttribute("data-transcript", obj.ids.join(","));
        modus === "ansicht" ? "" : div.classList.add("div-with-transcript");
      }
      return div.outerHTML;
    }
  },
  methods: {}
};
</script>
 
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// FormatHtml.vue?33f2f811